import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from './styles';
import ScheduleCard from 'common/ScheduleCard/ScheduleCard';
import Button from '../../components/Buttom/Button';
import IEvent from 'interfaces/IEvent';
import SubTitle from 'common/SubTitle/SubTitle';
import { formatDate } from 'utils/string';

interface Props {
  events?: IEvent[];
}

const Schedule = (props: Props): JSX.Element => {
  const sortEventsByProximity = (arr: IEvent[]) => {
    const today = new Date();
    const todayStart = Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate());

    return arr.sort((a, b) => {
      const diffA = a.startDate ? new Date(a.startDate).getTime() - todayStart : -Infinity;
      const diffB = b.startDate ? new Date(b.startDate).getTime() - todayStart : -Infinity;

      const isFutureA = diffA >= 0;
      const isFutureB = diffB >= 0;

      if (isFutureA && isFutureB) return diffA - diffB;
      if (isFutureA) return -1;
      if (isFutureB) return 1;

      return Math.abs(diffA) - Math.abs(diffB);
    });
  };

  const events = sortEventsByProximity(props.events || []);

  return (
    <Container>
      <SubTitle text="Agenda" />
      <ul>
        {events?.slice(0, 4).map(event => {
          return (
            <ScheduleCard
              key={event.id}
              category={event.category}
              dateStr={formatDate(event.startDate || '')}
              eventName={event.title}
              img={event.image}
              slug={event.slug ?? ''}
            />
          );
        })}
      </ul>
      <Link to="/events">
        <Button text="ver agenda completa" />
      </Link>
    </Container>
  );
};

export default Schedule;
